var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"text-center",attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"63","color":_vm.color}}),_c('p',{staticClass:"text-body mt-3"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }